import { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner, Breadcrumb } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import api from "../../../../api/api";
import InputFeild from "../../../../components/InputField";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import EditIcon from "@mui/icons-material/Edit";

const TermsAndConditions = () => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [terms, setTerms] = useState([]);
  const [newTerm, setNewTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [termToDelete, setTermToDelete] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editTermId, setEditTermId] = useState(null);
  const [editTerm, setEditTerm] = useState("");

  const options = [
    "LCL IMPORT - NON HAZ CARGO",
    "LCL IMPORT - HAZ CARGO",
    "LCL EXPORT - NON HAZ CARGO",
    "LCL EXPORT- HAZ CARGO",
    "FCL IMPORT - NON HAZ CARGO ( Dock Stuffing )",
    "FCL IMPORT - NON HAZ CARGO ( Factory Stuffing )",
    "FCL IMPORT - HAZ CARGO ( Dock Stuffing )",
    "FCL IMPORT - HAZ CARGO ( Factory Stuffing )",
    "FCL EXPORT- NON HAZ CARGO ( Dock Stuffing )",
    "FCL EXPORT- NON HAZ CARGO ( Factory Stuffing )",
    "FCL EXPORT- HAZ CARGO ( Dock Stuffing )",
    "FCL EXPORT- HAZ CARGO ( Factory Stuffing )",
    "FCL EXPORT- Russia / CIS Sector Via Iran",
  ];

  useEffect(() => {
    if (selectedCategory) {
      fetchTerms();
    } else {
      setTerms([]);
    }
  }, [selectedCategory]);

  const fetchTerms = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        `/master-data/terms-conditions?Parameter=${encodeURIComponent(
          selectedCategory,
        )}`,
      );
      setTerms(response.data.TandC);
    } catch (error) {
      console.error("Error fetching terms:", error);
      setTerms([]);
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (term) => {
    setEditTermId(term.TC_id);
    setEditTerm(term.TnC);
    setShowEditModal(true);
  };

  const handleUpdateTerm = async () => {
    if (!editTerm.trim()) return;

    try {
      await api.put(`/master-data/terms-conditions/${editTermId}`, {
        Parameter: selectedCategory,
        TnC: editTerm.trim(),
      });

      await fetchTerms();

      setShowEditModal(false);
      setEditTerm("");
      setEditTermId(null);
    } catch (error) {
      console.error("Error updating term:", error);
    }
  };

  const handleAddTerm = async () => {
    if (!newTerm.trim() || !selectedCategory) return;

    const newTermData = {
      Parameter: selectedCategory,
      TnC: newTerm.trim(),
    };

    try {
      const response = await api.post(
        `/master-data/terms-conditions`,
        newTermData,
      );
      const addedTerm = response.data;
      setTerms((prev) => [...prev, addedTerm]);
      setNewTerm("");
    } catch (error) {
      console.error("Error adding term:", error);
    }
  };

  const confirmDeleteTerm = (id) => {
    setTermToDelete(id);
    setShowDeleteModal(true);
  };

  const handleDeleteTerm = async () => {
    if (!termToDelete) return;

    try {
      await api.delete(`/master-data/terms-conditions/${termToDelete}`);
      await fetchTerms();
      setTerms((prev) => prev.filter((t) => t.TC_id !== termToDelete));
    } catch (error) {
      console.error("Error deleting term:", error);
    } finally {
      setShowDeleteModal(false);
      setTermToDelete(null);
    }
  };

  return (
    <>
      <Breadcrumbs />
      <div className="mb-3">
        <Form.Label>Parameter</Form.Label>
        <Form.Select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">Select Category</option>
          {options.map((opt, index) => (
            <option key={index} value={opt}>
              {opt}
            </option>
          ))}
        </Form.Select>
      </div>
      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : terms.length > 0 ? (
        <>
          <h4 className="subheading">{selectedCategory}</h4>
          <ul className="list-group">
            {terms.map((term) => (
              <li
                key={term.TC_id}
                style={{ fontSize: "0.875rem" }}
                className="list-group-item d-flex justify-content-between align-items-center fw-semibold"
              >
                <div className="d-flex justify-content-between align-items-center w-100">
                  <span>{term.TnC}</span>

                  <div className="d-flex gap-2">
                    <EditIcon
                      onClick={() => handleEditClick(term)}
                      style={{
                        cursor: "pointer",
                        color: "#7889a0",
                      }}
                    />

                    <DeleteOutlineIcon
                      onClick={() => confirmDeleteTerm(term.TC_id)}
                      style={{
                        cursor: "pointer",
                        color: "#7889a0",
                      }}
                    />
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </>
      ) : (
        selectedCategory && (
          <p className="text-muted">No terms found for this category.</p>
        )
      )}
      {selectedCategory && (
        <div className="row mt-3 g-2">
          <div className="col-sm-11">
            <InputFeild
              type="text"
              placeholder="Add new term & condition..."
              value={newTerm}
              onChange={(e) => setNewTerm(e.target.value)}
            />
          </div>
          <div className="col-sm-1">
            <Button
              variant="primary"
              onClick={handleAddTerm}
              disabled={!newTerm.trim()}
              className="mt-0"
            >
              <AddIcon />
            </Button>
          </div>
        </div>
      )}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this data?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteTerm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Terms & Conditions</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Terms & Conditions</Form.Label>

            <Form.Control
              as="textarea"
              rows={4}
              value={editTerm}
              onChange={(e) => setEditTerm(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handleUpdateTerm}
            disabled={!editTerm.trim()}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TermsAndConditions;